import { memo, useEffect } from 'react';
import { useMap as useMapLeaflet } from 'react-leaflet';

import L from 'leaflet';
import 'leaflet-pegman';
import 'leaflet-pegman/leaflet-pegman.css';

const StreetView = () => {
  const map = useMapLeaflet();

  useEffect(() => {
    // @ts-ignore
    const pegman = new L.Control.Pegman({
      position: 'bottomleft',
      theme: 'leaflet-pegman-v3-small',
    });

    pegman.addTo(map);
  }, []);

  return null;
};

export default memo(StreetView);
